import React from "react";
// import {ProgressSpinner} from "primereact/progressspinner";

class Loader extends React.Component {

    render() {
        return (
            // <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
            <div className="loader-box">
                <div className="loader-2">

                </div>
            </div>
        )
    }

}

export default Loader